import { LockIcon } from "@chakra-ui/icons";
import { Box, Flex, FormLabel, Icon, Text } from "@chakra-ui/react";
import { Select } from "chakra-react-select";
import { EditFormValues } from "features/transactions/TableViewCreateOrUpdateModal/TableViewCreateOrUpdateModal";
import { useUsersMeRetrieveSuspense } from "gen/endpoints/users/users";
import { TableViewUpdateAPIDataRequestVisibleTo } from "gen/model/tableViewUpdateAPIDataRequestVisibleTo";
import { useMemo } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaGlobe } from "react-icons/fa6";

interface Option {
  label: React.ReactNode;
  value: TableViewUpdateAPIDataRequestVisibleTo | undefined;
}

export const useVisibilitySelector = ({
  form,
}: {
  form: UseFormReturn<EditFormValues>;
}) => {
  const { t } = useTranslation(["views"]);
  const { data: userData } = useUsersMeRetrieveSuspense();

  const permOptions: Option[] = useMemo(
    () => [
      {
        value: userData.id,
        label: (
          <Flex alignItems="center">
            <LockIcon mr={2} />
            <Text>Only me</Text>
          </Flex>
        ),
      },
      {
        value: "",
        label: (
          <Flex alignItems="center">
            <Icon as={FaGlobe} mr={2} />
            <Text>Organization</Text>
          </Flex>
        ),
      },
    ],
    [userData.id],
  );

  return {
    permOptions,
    visibilitySelector: (
      <Controller
        shouldUnregister={false}
        name="visible_to"
        control={form.control}
        render={({ field }) => {
          const selectedOption = permOptions.find(
            (option) => option.value === field.value,
          );
          return (
            <Box>
              <FormLabel fontSize="xs" htmlFor="visible_to">
                {t("views:modal.visibilityLabel")}
              </FormLabel>
              <Select
                {...field}
                options={permOptions}
                placeholder={t("views:modal.visibilityPlaceholder")}
                onChange={(selectedOption: Option | null) => {
                  field.onChange(selectedOption?.value);
                }}
                value={selectedOption}
              />
            </Box>
          );
        }}
      />
    ),
  };
};
